import MainPageCategories from "./MainPageCarousel";
import MainPageCategoryView from "./MainPageCategory";
import MainPageLatestProduct from "./MainPageLatestProduct";
import MainPageManage from "./MainPageManage";
import MainPageSaleProduct from "./MainPageSaleProduct";

export default function MainPage() {
  return (
    <div className="main-page-wrapper md:mx-16">
      {/* Categories */}
      <MainPageCategories />

      <MainPageManage />

      <MainPageCategoryView />

      {/* Is discounting product */}
      <MainPageSaleProduct />

      {/* Latest product */}
      <MainPageLatestProduct />
    </div>
  );
}
